import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import useResponsive from "../../hooks/useResponsive";
import { FacilityDataPropsType } from "../../interface/users";
import { useTheme } from "@mui/material/styles";
import { formatDateFromString } from "../../utils/url-id";
import AvatarImage from "../UIElements/avatar-image";
import { addSpaceAfterComma, cleanCommas } from "../../utils/major-functions";
const headerSty = {
  fontFamily: "Lexend",
  letterSpacing: "0.01em",
  fontWeight: 400,
};
const contentSty = {
  fontFamily: "Lexend",
  letterSpacing: "0.01em",
  fontWeight: 400,
};

const ProfileTop = ({
  facility_info,
}: {
  facility_info: FacilityDataPropsType;
}) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");

  return (
    <>
      <Box sx={{ display: "flex", gap: 3, alignItems: " center" }}>
        <AvatarImage width={120} height={120} name={facility_info?.name} />
        <Stack>
          <Typography
            variant="h3"
            sx={{ fontWeight: 600, fontFamily: "Outfit", margin: 0 }}
            color={"neutral"}
          >
            {facility_info?.name}
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontFamily: "Outfit", color: "#2C393F", margin: 0 }}
          >
            {facility_info.email}
          </Typography>
        </Stack>
      </Box>
      <Box
        sx={{
          backgroundColor: "#F7F8F9",
          borderRadius: "4",
          paddingLeft: 3,
          paddingY: "1.3rem",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          minHeight: 70,
          my: 4,
        }}
      >
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Type
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.facility_type}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Size
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.facility_size}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Role
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.role}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            IsVerified
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {`${facility_info?.isVerified}`}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Joined On
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.created_at.length > 3 &&
              formatDateFromString(facility_info?.created_at)}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Verification
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.verification ?? "-"}
          </Typography>
        </Stack>
      </Box>
      <Box
        sx={{
          backgroundColor: "#F7F8F9",
          borderRadius: "4",
          paddingLeft: 3,
          paddingY: "1.3rem",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          minHeight: 70,
          my: 4,
          gap: 3,
        }}
      >
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            State
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.state ?? "-"}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Reg No
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.reg_no ?? "-"}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            City
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.city ?? "-"}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Address
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {`${facility_info?.address ?? "-"}`}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Phone Number
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.phone_number ?? "-"}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Contact Name
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.contact_name ?? "-"}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Contact Title
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {facility_info?.contact_job_title ?? "-"}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Specialties
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {cleanCommas(facility_info?.specialties)}
          </Typography>
        </Stack>
      </Box>
    </>
  );
};

export default ProfileTop;
